import { writable } from 'svelte/store';

export const dataStore = writable({
	perPage: 20,
	page: 1,
	results: [],
	loading: false,
	totalCount: null,
	filters: {
		vt:  null, // Vehicle type
		bd:  null, // Brand
		bt:  null, // Model
		ct:  null, // Cabin
		gb:  null, // Gearbox
		sup: null, // Superstructure
	},
});

export const local = window?.wordpress_object?.lang || 'DE';
export const appRoute = window?.wordpress_object?.routename || false;
export const img_base = window?.wordpress_object?.img_base || false;
export const img_replace_rule = window?.wordpress_object?.img_replace_rule || false;
export const style = window?.wordpress_object?.style || 'BTS';
export const vehicle_type = window?.wordpress_object?.filter_vehicle_type || false;

let contact_form = window?.wordpress_object?.contact_form || false;
export const useContactForm = contact_form === "" || !contact_form ? false : true;